import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '&.message-button': {
    fontSize: theme.fontSizes[1],
  },
});
